module.exports = __webpack_public_path__ + "fonts/Barlow-600.295e5d7.woff";